import {onDomReady} from "./observer.js";

class DatingFilter {
    constructor() {
        this.options = {
            datingFilterAdv: '[data-vipfilter]',
            datingFilterAdvBack: '[data-vipfilter-back]',
            datingFilterAdvClose: '[data-vipfilter-close]',
            datingFilterAdvOverlay: '[data-vipfilter-overlay]',
            datingFilterAdvOpener: '[data-vipfilter-opener]',
            datingFilterAdvReset: '[data-vipfilter-reset-adv]',
            datingFilterReset: '[ data-vipfilter-reset]',
            datingFilterAdvSearch: '[data-vipfilter-search-adv]',
            datingFilterOverlayOpened: '_opened',
            entirePage: '[data-body]',
            noScroll: 'body-fixed',
        };

        this.elements = {
            entirePageElement: document.querySelector(this.options.entirePage),
            datingFilterAdvElement: document.querySelector(this.options.datingFilterAdv),
            datingFilterAdvBackElement: document.querySelector(this.options.datingFilterAdvBack),
            datingFilterAdvCloseElement: document.querySelector(this.options.datingFilterAdvClose),
            datingFilterAdvOverlayElement: document.querySelector(this.options.datingFilterAdvOverlay),
            datingFilterAdvOpenerElement: document.querySelector(this.options.datingFilterAdvOpener),
            datingFilterAdvResetElement: document.querySelector(this.options.datingFilterAdvReset),
            datingFilterResetElement: document.querySelector(this.options.datingFilterReset),
            datingFilterAdvSearchElement: document.querySelector(this.options.datingFilterAdvSearch),
            datingFilterOverlayOpenedElement: document.querySelector(this.options.datingFilterOverlayOpened),
        };

        this.init();
    }

    init() {

        if (this.elements.datingFilterAdvBackElement &&
            this.elements.datingFilterAdvCloseElement &&
            this.elements.datingFilterAdvOverlayElement &&
            this.elements.datingFilterAdvSearchElement &&
            this.elements.datingFilterAdvOpenerElement &&
            this.elements.entirePageElement &&
            this.elements.datingFilterAdvElement) {

            const vipFilter = this.elements.datingFilterAdvElement;
            const vipFilterOverlay = this.elements.datingFilterAdvOverlayElement;
            const vipFilterBack = this.elements.datingFilterAdvBackElement;
            const vipFilterClose = this.elements.datingFilterAdvCloseElement;
            const vipFilterOpener = this.elements.datingFilterAdvOpenerElement;
            const entirePage = this.elements.entirePageElement;

            vipFilterOpener.addEventListener('click', () => {
                vipFilterOverlay.classList.add(this.options.datingFilterOverlayOpened);
                vipFilter.classList.add(this.options.datingFilterOverlayOpened);
                entirePage.classList.add(this.options.noScroll);
            });
            vipFilterBack.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

            vipFilterClose.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

            vipFilterOverlay.addEventListener('click', () => {
                vipFilterOverlay.classList.remove(this.options.datingFilterOverlayOpened);
                vipFilter.classList.remove(this.options.datingFilterOverlayOpened);
                entirePage.classList.remove(this.options.noScroll);
            });

        }
    }
}

onDomReady(() => {
    const header = new DatingFilter();
}, false);